import { render, staticRenderFns } from "./DeviceConnectionList.vue?vue&type=template&id=2076ff22&scoped=true"
import script from "./DeviceConnectionList.vue?vue&type=script&lang=js"
export * from "./DeviceConnectionList.vue?vue&type=script&lang=js"
import style0 from "./DeviceConnectionList.vue?vue&type=style&index=0&id=2076ff22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076ff22",
  null
  
)

export default component.exports